import { restrictedAccess } from '../middleware'

export default {
  path: 'completion-reports',
  component: () => import('@/views/admin/completion-reports/Page.vue'),
  beforeEnter: restrictedAccess(1),
  children: [
    {
      name: 'CompletionReports.Index',
      path: '',
      component: () => import('@/views/admin/completion-reports/Index.vue'),
    },
    {
      name: 'CompletionReports.Create',
      path: 'create',
      component: () => import('@/views/admin/completion-reports/Create.vue'),
    },
    {
      name: 'CompletionReports.Edit',
      path: ':completionReportId/edit',
      component: () => import('@/views/admin/completion-reports/Edit.vue'),
    },
    {
      name: 'CompletionReports.Show',
      path: ':completionReportId/show',
      component: () => import('@/views/admin/completion-reports/Show.vue'),
    },
  ],
}